import { Component, OnInit } from '@angular/core';
import { IFinalPaperReviewListItem, IFinalPaperYear } from '../../models/FinalPaperReview';
import { AppService } from '../../services/app.service';
import { FinalPaperReviewService } from '../../services/final-paper-review.service';
import { IPersonSearchResultItem } from 'src/app/models/Person';
import { PersonType } from 'src/app/shared/person-picker/person-picker.component';
import { store } from './store';

const cache: { years?: IFinalPaperYear[] } = {};

@Component({
    selector: 'app-final-paper-review-home',
    templateUrl: './final-paper-review-home.component.html'
})
export class FinalPaperReviewHomeComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: FinalPaperReviewService
    ) { }

    selectedPeriodId: string;
    finalPapers: IFinalPaperReviewListItem[] = [];
    showProtocols: boolean;
    showOrders: boolean;

    personPickerOpened: boolean;
    canPickEmployee: boolean;
    person: IPersonSearchResultItem;

    readonly personPickerType: PersonType = "employee";

    readonly options: {
        period: { id: string, name: string, isChild?: boolean }[]
    } = {
            period: []
        };

    private isAdmin: boolean;

    ngOnInit() {
        const user = this.app.currentUser;

        this.isAdmin = user?.hasRight('FINAL_PAPER_REVIEW.ADMIN');
        this.canPickEmployee = user?.hasRight('FINAL_PAPER_REVIEW.SET_EMPLOYEE_VIEW') || user?.hasRight('FINAL_PAPER_REVIEW.SET_EMPLOYEE_ADMIN');
        this.showProtocols = user?.hasRight('FINAL_PAPER_PROTOCOL.VIEW');
        this.showOrders = user?.hasRight('FINAL_PAPER_ORDER.VIEW');

        this.loadYears();
    }

    onPeriodChange() {
        this.reload();
    }

    setPerson(person: IPersonSearchResultItem) {
        this.personPickerOpened = false;
        this.person = person;
        store.setPerson(person);
        this.reload();
    }

    togglePersonPicker() {
        this.personPickerOpened = !this.personPickerOpened;
    }

    private reload() {
        this.app.addLoading(this.service.get(this.selectedPeriodId, store.getPerson()?.Upn)).subscribe(data => {
            this.finalPapers = data.Items;
        });
    }

    private loadYears() {
        const go = (data: IFinalPaperYear[]) => {
            data.sort((a, b) => b.Index - a.Index);

            let selectedId: string;

            this.options.period = data.reduce((all, y) => {
                all.push({ id: y.Id, name: y.Name });

                if (y.IsActual) selectedId = y.Id;

                y.Semesters.sort((a, b) => b.Index - a.Index);

                y.Semesters.forEach(s => {
                    all.push({ id: s.Id, name: s.Name, isChild: true });

                    if (s.IsActual) selectedId = s.Id;
                });

                return all;
            }, []);

            this.selectedPeriodId = selectedId;

            if (this.selectedPeriodId) {
                this.onPeriodChange();
            }
        };

        if (cache.years) {
            go(cache.years);
        } else {
            this.app.addLoading(this.service.getPeriods()).subscribe(data => {
                cache.years = data;
                go(data);
            });
        }
    }
}
